"use strict";
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.0.4.0 (NJsonSchema v10.0.21.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteSettingType = exports.DebtorReferenceType = exports.PaymentAgreementOrderState = exports.StatusState = exports.MaintenanceType = exports.CarNewValueActionType = exports.CoverDisallowedReason = exports.AccidentScopeType = exports.CustomerTaskType = exports.CustomerSplashType = exports.RkiRegistered = exports.TicketStatus = exports.CustomerKeyValueType = exports.CoverPriceType = exports.DeductibleType = exports.BlockedPolicyReason = exports.DocumentType = exports.InsurancePolicyState = exports.ClaimDraftFieldType = exports.ProductType = exports.EmailVerificationType = exports.PaymentMethod = exports.Language = exports.CommunicationMediaType = exports.CollectionState = exports.CollectionType = exports.ClaimDraftState = exports.ClaimType = exports.ClaimState = exports.Campaign = exports.BasketHeardAboutType = void 0;
var BasketHeardAboutType;
(function (BasketHeardAboutType) {
    BasketHeardAboutType[BasketHeardAboutType["NotSpecified"] = 0] = "NotSpecified";
    BasketHeardAboutType[BasketHeardAboutType["Google"] = 1] = "Google";
    BasketHeardAboutType[BasketHeardAboutType["ComparingPartner"] = 2] = "ComparingPartner";
    BasketHeardAboutType[BasketHeardAboutType["Facebook"] = 3] = "Facebook";
    BasketHeardAboutType[BasketHeardAboutType["FriendsOrFamily"] = 4] = "FriendsOrFamily";
    BasketHeardAboutType[BasketHeardAboutType["OnlineBanner"] = 5] = "OnlineBanner";
    BasketHeardAboutType[BasketHeardAboutType["NoRecollection"] = 99] = "NoRecollection";
})(BasketHeardAboutType || (exports.BasketHeardAboutType = BasketHeardAboutType = {}));
var Campaign;
(function (Campaign) {
    Campaign[Campaign["HouseAndHome20PercentDiscount"] = 1] = "HouseAndHome20PercentDiscount";
})(Campaign || (exports.Campaign = Campaign = {}));
var ClaimState;
(function (ClaimState) {
    ClaimState[ClaimState["Ongoing"] = 1] = "Ongoing";
    ClaimState[ClaimState["Finished"] = 2] = "Finished";
})(ClaimState || (exports.ClaimState = ClaimState = {}));
var ClaimType;
(function (ClaimType) {
    ClaimType[ClaimType["Unknown"] = 0] = "Unknown";
    ClaimType[ClaimType["GlassDamage"] = 1] = "GlassDamage";
    ClaimType[ClaimType["TrafficAccident"] = 2] = "TrafficAccident";
    ClaimType[ClaimType["SingleAccident"] = 3] = "SingleAccident";
    ClaimType[ClaimType["TheftFrom"] = 4] = "TheftFrom";
    ClaimType[ClaimType["Vandalism"] = 5] = "Vandalism";
    ClaimType[ClaimType["TheftOfCar"] = 6] = "TheftOfCar";
    ClaimType[ClaimType["Fire"] = 7] = "Fire";
    ClaimType[ClaimType["LegalAid"] = 8] = "LegalAid";
    ClaimType[ClaimType["MentalCounselling"] = 9] = "MentalCounselling";
    ClaimType[ClaimType["HouseBreaking"] = 10] = "HouseBreaking";
    ClaimType[ClaimType["BicycleTheft"] = 11] = "BicycleTheft";
    ClaimType[ClaimType["SimpleTheft"] = 12] = "SimpleTheft";
    ClaimType[ClaimType["Robbery"] = 13] = "Robbery";
    ClaimType[ClaimType["ElectricalDamage"] = 14] = "ElectricalDamage";
    ClaimType[ClaimType["WaterDamage"] = 15] = "WaterDamage";
    ClaimType[ClaimType["RefrigeratedGoodsDamage"] = 16] = "RefrigeratedGoodsDamage";
    ClaimType[ClaimType["Baggage"] = 17] = "Baggage";
    ClaimType[ClaimType["Liability"] = 18] = "Liability";
    ClaimType[ClaimType["ExpandedElectronicDamage"] = 19] = "ExpandedElectronicDamage";
    ClaimType[ClaimType["TravelAndTravelCancel"] = 20] = "TravelAndTravelCancel";
    ClaimType[ClaimType["SuddenDamage"] = 21] = "SuddenDamage";
    ClaimType[ClaimType["DamageToOtherAnimals"] = 22] = "DamageToOtherAnimals";
    ClaimType[ClaimType["DamageToObjects"] = 23] = "DamageToObjects";
    ClaimType[ClaimType["DamageToPersons"] = 24] = "DamageToPersons";
    ClaimType[ClaimType["Illness"] = 25] = "Illness";
    ClaimType[ClaimType["AccidentWithImplicated"] = 26] = "AccidentWithImplicated";
    ClaimType[ClaimType["ContentsDamage"] = 27] = "ContentsDamage";
    ClaimType[ClaimType["DentalDamage"] = 28] = "DentalDamage";
    ClaimType[ClaimType["Disability"] = 29] = "Disability";
    ClaimType[ClaimType["DentalDamageChild"] = 30] = "DentalDamageChild";
    ClaimType[ClaimType["GlassSanitation"] = 31] = "GlassSanitation";
    ClaimType[ClaimType["PipeDamage"] = 32] = "PipeDamage";
    ClaimType[ClaimType["OutdoorPipes"] = 33] = "OutdoorPipes";
    ClaimType[ClaimType["WeatherDamage"] = 34] = "WeatherDamage";
    ClaimType[ClaimType["FungusInsect"] = 35] = "FungusInsect";
    ClaimType[ClaimType["Rot"] = 36] = "Rot";
    ClaimType[ClaimType["LeakingWater"] = 37] = "LeakingWater";
    ClaimType[ClaimType["ExpandedWaterDamage"] = 38] = "ExpandedWaterDamage";
    ClaimType[ClaimType["Pests"] = 39] = "Pests";
    ClaimType[ClaimType["RoadsideAssistance"] = 40] = "RoadsideAssistance";
    ClaimType[ClaimType["Death"] = 41] = "Death";
    ClaimType[ClaimType["DriverAccident"] = 42] = "DriverAccident";
    ClaimType[ClaimType["Injury"] = 43] = "Injury";
    ClaimType[ClaimType["HouseLiability"] = 44] = "HouseLiability";
    ClaimType[ClaimType["SoloAccident"] = 45] = "SoloAccident";
    ClaimType[ClaimType["TheftOfCaravan"] = 46] = "TheftOfCaravan";
    ClaimType[ClaimType["TheftFromCaravan"] = 47] = "TheftFromCaravan";
    ClaimType[ClaimType["HouseBreakingHome"] = 48] = "HouseBreakingHome";
    ClaimType[ClaimType["SimpleHouseBreaking"] = 49] = "SimpleHouseBreaking";
    ClaimType[ClaimType["SimpleTheftHome"] = 50] = "SimpleTheftHome";
    ClaimType[ClaimType["RanRobbery"] = 51] = "RanRobbery";
    ClaimType[ClaimType["VandalismHome"] = 52] = "VandalismHome";
    ClaimType[ClaimType["ElectricalDamageHome"] = 53] = "ElectricalDamageHome";
    ClaimType[ClaimType["Theft"] = 54] = "Theft";
    ClaimType[ClaimType["FireShorting"] = 55] = "FireShorting";
    ClaimType[ClaimType["FungusInsectDamage"] = 56] = "FungusInsectDamage";
    ClaimType[ClaimType["FireHome"] = 57] = "FireHome";
    ClaimType[ClaimType["WaterDamageHome"] = 58] = "WaterDamageHome";
    ClaimType[ClaimType["OtherDamage"] = 999] = "OtherDamage";
})(ClaimType || (exports.ClaimType = ClaimType = {}));
var ClaimDraftState;
(function (ClaimDraftState) {
    ClaimDraftState[ClaimDraftState["NotSet"] = 0] = "NotSet";
    ClaimDraftState[ClaimDraftState["Ongoing"] = 1] = "Ongoing";
    ClaimDraftState[ClaimDraftState["Submitted"] = 2] = "Submitted";
})(ClaimDraftState || (exports.ClaimDraftState = ClaimDraftState = {}));
var CollectionType;
(function (CollectionType) {
    CollectionType[CollectionType["Unknown"] = 0] = "Unknown";
    CollectionType[CollectionType["Collection"] = 1] = "Collection";
    CollectionType[CollectionType["ReimbursementClaim"] = 2] = "ReimbursementClaim";
    CollectionType[CollectionType["Reminder"] = 3] = "Reminder";
})(CollectionType || (exports.CollectionType = CollectionType = {}));
var CollectionState;
(function (CollectionState) {
    CollectionState[CollectionState["Open"] = 0] = "Open";
    CollectionState[CollectionState["Payed"] = 1] = "Payed";
    CollectionState[CollectionState["Canceled"] = 2] = "Canceled";
    CollectionState[CollectionState["Credited"] = 6] = "Credited";
    CollectionState[CollectionState["InReminderFlow"] = 90] = "InReminderFlow";
})(CollectionState || (exports.CollectionState = CollectionState = {}));
var CommunicationMediaType;
(function (CommunicationMediaType) {
    CommunicationMediaType[CommunicationMediaType["Email"] = 1] = "Email";
    CommunicationMediaType[CommunicationMediaType["Sms"] = 2] = "Sms";
})(CommunicationMediaType || (exports.CommunicationMediaType = CommunicationMediaType = {}));
var Language;
(function (Language) {
    Language[Language["Danish"] = 0] = "Danish";
    Language[Language["English"] = 1] = "English";
})(Language || (exports.Language = Language = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod[PaymentMethod["NotSelected"] = 0] = "NotSelected";
    PaymentMethod[PaymentMethod["CreditCard"] = 100] = "CreditCard";
    PaymentMethod[PaymentMethod["BetalingsService"] = 200] = "BetalingsService";
    PaymentMethod[PaymentMethod["MobilePay"] = 300] = "MobilePay";
    PaymentMethod[PaymentMethod["Giro"] = 400] = "Giro";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
var EmailVerificationType;
(function (EmailVerificationType) {
    EmailVerificationType[EmailVerificationType["Verify"] = 1] = "Verify";
    EmailVerificationType[EmailVerificationType["ChangeEmailAndVerify"] = 2] = "ChangeEmailAndVerify";
})(EmailVerificationType || (exports.EmailVerificationType = EmailVerificationType = {}));
var ProductType;
(function (ProductType) {
    ProductType[ProductType["Car"] = 0] = "Car";
    ProductType[ProductType["House"] = 1] = "House";
    ProductType[ProductType["Home"] = 2] = "Home";
    ProductType[ProductType["Accident"] = 3] = "Accident";
    ProductType[ProductType["Dog"] = 4] = "Dog";
    ProductType[ProductType["Moped"] = 5] = "Moped";
    ProductType[ProductType["Caravan"] = 6] = "Caravan";
    ProductType[ProductType["SecondHouse"] = 7] = "SecondHouse";
    ProductType[ProductType["CarSimple"] = 8] = "CarSimple";
})(ProductType || (exports.ProductType = ProductType = {}));
var ClaimDraftFieldType;
(function (ClaimDraftFieldType) {
    ClaimDraftFieldType[ClaimDraftFieldType["Textbox"] = 1] = "Textbox";
    ClaimDraftFieldType[ClaimDraftFieldType["Checkbox"] = 2] = "Checkbox";
    ClaimDraftFieldType[ClaimDraftFieldType["Radiobutton"] = 3] = "Radiobutton";
    ClaimDraftFieldType[ClaimDraftFieldType["Dropdown"] = 4] = "Dropdown";
    ClaimDraftFieldType[ClaimDraftFieldType["Textarea"] = 5] = "Textarea";
    ClaimDraftFieldType[ClaimDraftFieldType["TextboxNumeric"] = 6] = "TextboxNumeric";
    ClaimDraftFieldType[ClaimDraftFieldType["Datepicker"] = 7] = "Datepicker";
    ClaimDraftFieldType[ClaimDraftFieldType["YesThen"] = 8] = "YesThen";
    ClaimDraftFieldType[ClaimDraftFieldType["Repairshop"] = 9] = "Repairshop";
    ClaimDraftFieldType[ClaimDraftFieldType["YesThenMany"] = 10] = "YesThenMany";
})(ClaimDraftFieldType || (exports.ClaimDraftFieldType = ClaimDraftFieldType = {}));
var InsurancePolicyState;
(function (InsurancePolicyState) {
    InsurancePolicyState[InsurancePolicyState["Unknown"] = 0] = "Unknown";
    InsurancePolicyState[InsurancePolicyState["Active"] = 1] = "Active";
    InsurancePolicyState[InsurancePolicyState["Pending"] = 2] = "Pending";
    InsurancePolicyState[InsurancePolicyState["FutureActive"] = 3] = "FutureActive";
    InsurancePolicyState[InsurancePolicyState["Cancelled"] = 4] = "Cancelled";
    InsurancePolicyState[InsurancePolicyState["Terminated"] = 5] = "Terminated";
})(InsurancePolicyState || (exports.InsurancePolicyState = InsurancePolicyState = {}));
var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["CommunicationAttachment"] = 0] = "CommunicationAttachment";
    DocumentType[DocumentType["ConsentDocument"] = 1] = "ConsentDocument";
    DocumentType[DocumentType["ProductTerms"] = 2] = "ProductTerms";
    DocumentType[DocumentType["Collection"] = 3] = "Collection";
    DocumentType[DocumentType["RoadsideAssistanceCard"] = 4] = "RoadsideAssistanceCard";
    DocumentType[DocumentType["TravelCard"] = 5] = "TravelCard";
    DocumentType[DocumentType["RedCard"] = 6] = "RedCard";
    DocumentType[DocumentType["GreenCard"] = 7] = "GreenCard";
    DocumentType[DocumentType["PolicyDocument"] = 8] = "PolicyDocument";
    DocumentType[DocumentType["PolicyTerms"] = 9] = "PolicyTerms";
    DocumentType[DocumentType["MopedDocument"] = 10] = "MopedDocument";
    DocumentType[DocumentType["AgeExclusionDocument"] = 11] = "AgeExclusionDocument";
    DocumentType[DocumentType["ClaimCollectionDocument"] = 12] = "ClaimCollectionDocument";
    DocumentType[DocumentType["ClaimPayoutDocument"] = 13] = "ClaimPayoutDocument";
    DocumentType[DocumentType["CollectionPayoutDocument"] = 14] = "CollectionPayoutDocument";
    DocumentType[DocumentType["DebtCollectionThreatDocument"] = 15] = "DebtCollectionThreatDocument";
    DocumentType[DocumentType["DebtReminderDocument"] = 16] = "DebtReminderDocument";
    DocumentType[DocumentType["HomeReason"] = 17] = "HomeReason";
    DocumentType[DocumentType["ClaimHistory"] = 18] = "ClaimHistory";
})(DocumentType || (exports.DocumentType = DocumentType = {}));
var BlockedPolicyReason;
(function (BlockedPolicyReason) {
    BlockedPolicyReason[BlockedPolicyReason["NotBlocked"] = 0] = "NotBlocked";
    BlockedPolicyReason[BlockedPolicyReason["Dunning"] = 1] = "Dunning";
    BlockedPolicyReason[BlockedPolicyReason["Terminated"] = 2] = "Terminated";
    BlockedPolicyReason[BlockedPolicyReason["TerminateRequestedByCustomer"] = 3] = "TerminateRequestedByCustomer";
    BlockedPolicyReason[BlockedPolicyReason["Other"] = 999] = "Other";
})(BlockedPolicyReason || (exports.BlockedPolicyReason = BlockedPolicyReason = {}));
var DeductibleType;
(function (DeductibleType) {
    DeductibleType[DeductibleType["None"] = 0] = "None";
    DeductibleType[DeductibleType["Amount"] = 1] = "Amount";
    DeductibleType[DeductibleType["Terms"] = 2] = "Terms";
    DeductibleType[DeductibleType["Policy"] = 3] = "Policy";
})(DeductibleType || (exports.DeductibleType = DeductibleType = {}));
var CoverPriceType;
(function (CoverPriceType) {
    CoverPriceType[CoverPriceType["CoverPrice"] = 1] = "CoverPrice";
    CoverPriceType[CoverPriceType["EffectOtherCoverPrices"] = 2] = "EffectOtherCoverPrices";
})(CoverPriceType || (exports.CoverPriceType = CoverPriceType = {}));
var CustomerKeyValueType;
(function (CustomerKeyValueType) {
    CustomerKeyValueType[CustomerKeyValueType["Unknown"] = 0] = "Unknown";
    CustomerKeyValueType[CustomerKeyValueType["TaskIntroViewed"] = 1] = "TaskIntroViewed";
    CustomerKeyValueType[CustomerKeyValueType["TrustpilotReviewLink"] = 2] = "TrustpilotReviewLink";
    CustomerKeyValueType[CustomerKeyValueType["DetailsUpdated"] = 3] = "DetailsUpdated";
    CustomerKeyValueType[CustomerKeyValueType["TrustpilotCompetitionParticipate"] = 4] = "TrustpilotCompetitionParticipate";
})(CustomerKeyValueType || (exports.CustomerKeyValueType = CustomerKeyValueType = {}));
var TicketStatus;
(function (TicketStatus) {
    TicketStatus[TicketStatus["Unknown"] = 0] = "Unknown";
    TicketStatus[TicketStatus["Open"] = 1] = "Open";
    TicketStatus[TicketStatus["Closed"] = 2] = "Closed";
    TicketStatus[TicketStatus["Solved"] = 3] = "Solved";
    TicketStatus[TicketStatus["New"] = 4] = "New";
    TicketStatus[TicketStatus["Pending"] = 5] = "Pending";
})(TicketStatus || (exports.TicketStatus = TicketStatus = {}));
var RkiRegistered;
(function (RkiRegistered) {
    RkiRegistered[RkiRegistered["No"] = 0] = "No";
    RkiRegistered[RkiRegistered["Yes"] = 1] = "Yes";
    RkiRegistered[RkiRegistered["Unanswered"] = 2] = "Unanswered";
    RkiRegistered[RkiRegistered["Anonymized"] = 3] = "Anonymized";
})(RkiRegistered || (exports.RkiRegistered = RkiRegistered = {}));
var CustomerSplashType;
(function (CustomerSplashType) {
    CustomerSplashType[CustomerSplashType["None"] = 0] = "None";
    CustomerSplashType[CustomerSplashType["UpdateContactInfo"] = 1] = "UpdateContactInfo";
    CustomerSplashType[CustomerSplashType["TrustpilotReviewLink"] = 2] = "TrustpilotReviewLink";
    CustomerSplashType[CustomerSplashType["HomeHouse20PercentCampaign"] = 3] = "HomeHouse20PercentCampaign";
})(CustomerSplashType || (exports.CustomerSplashType = CustomerSplashType = {}));
var CustomerTaskType;
(function (CustomerTaskType) {
    CustomerTaskType[CustomerTaskType["PaymentAgreement"] = 1] = "PaymentAgreement";
    CustomerTaskType[CustomerTaskType["ClaimHistory"] = 2] = "ClaimHistory";
    CustomerTaskType[CustomerTaskType["OfferActivation"] = 3] = "OfferActivation";
    CustomerTaskType[CustomerTaskType["OfferApproval"] = 4] = "OfferApproval";
    CustomerTaskType[CustomerTaskType["Consent"] = 5] = "Consent";
})(CustomerTaskType || (exports.CustomerTaskType = CustomerTaskType = {}));
var AccidentScopeType;
(function (AccidentScopeType) {
    AccidentScopeType[AccidentScopeType["Full"] = 1] = "Full";
    AccidentScopeType[AccidentScopeType["Leisure"] = 2] = "Leisure";
    AccidentScopeType[AccidentScopeType["Child"] = 3] = "Child";
})(AccidentScopeType || (exports.AccidentScopeType = AccidentScopeType = {}));
var CoverDisallowedReason;
(function (CoverDisallowedReason) {
    CoverDisallowedReason[CoverDisallowedReason["VehicleToOld"] = 0] = "VehicleToOld";
    CoverDisallowedReason[CoverDisallowedReason["VehicleValueTooHigh"] = 1] = "VehicleValueTooHigh";
})(CoverDisallowedReason || (exports.CoverDisallowedReason = CoverDisallowedReason = {}));
var CarNewValueActionType;
(function (CarNewValueActionType) {
    CarNewValueActionType[CarNewValueActionType["None"] = 0] = "None";
    CarNewValueActionType[CarNewValueActionType["TheftProtection"] = 1] = "TheftProtection";
    CarNewValueActionType[CarNewValueActionType["OrderNotAllowed"] = 99] = "OrderNotAllowed";
})(CarNewValueActionType || (exports.CarNewValueActionType = CarNewValueActionType = {}));
var MaintenanceType;
(function (MaintenanceType) {
    MaintenanceType[MaintenanceType["General"] = 1] = "General";
    MaintenanceType[MaintenanceType["Dmr"] = 2] = "Dmr";
    MaintenanceType[MaintenanceType["Cpr"] = 3] = "Cpr";
    MaintenanceType[MaintenanceType["Selfcare"] = 4] = "Selfcare";
})(MaintenanceType || (exports.MaintenanceType = MaintenanceType = {}));
var StatusState;
(function (StatusState) {
    StatusState[StatusState["Unknown"] = 0] = "Unknown";
    StatusState[StatusState["Ok"] = 1] = "Ok";
    StatusState[StatusState["Unstable"] = 2] = "Unstable";
    StatusState[StatusState["Maintenance"] = 3] = "Maintenance";
})(StatusState || (exports.StatusState = StatusState = {}));
var PaymentAgreementOrderState;
(function (PaymentAgreementOrderState) {
    PaymentAgreementOrderState[PaymentAgreementOrderState["New"] = 0] = "New";
    PaymentAgreementOrderState[PaymentAgreementOrderState["Completed"] = 10] = "Completed";
    PaymentAgreementOrderState[PaymentAgreementOrderState["Failed"] = 99] = "Failed";
})(PaymentAgreementOrderState || (exports.PaymentAgreementOrderState = PaymentAgreementOrderState = {}));
var DebtorReferenceType;
(function (DebtorReferenceType) {
    DebtorReferenceType[DebtorReferenceType["NotSelected"] = 0] = "NotSelected";
    DebtorReferenceType[DebtorReferenceType["Basket"] = 1] = "Basket";
    DebtorReferenceType[DebtorReferenceType["Customer"] = 2] = "Customer";
})(DebtorReferenceType || (exports.DebtorReferenceType = DebtorReferenceType = {}));
var SiteSettingType;
(function (SiteSettingType) {
    SiteSettingType[SiteSettingType["ContactRequestDisabled"] = 0] = "ContactRequestDisabled";
    SiteSettingType[SiteSettingType["MaxAllowedContactRequests"] = 1] = "MaxAllowedContactRequests";
    SiteSettingType[SiteSettingType["ContactRequestDefaultDisabled"] = 2] = "ContactRequestDefaultDisabled";
    SiteSettingType[SiteSettingType["DisplayNextPhoneNumber"] = 3] = "DisplayNextPhoneNumber";
    SiteSettingType[SiteSettingType["ConsentProductModal"] = 5] = "ConsentProductModal";
    SiteSettingType[SiteSettingType["OfferContactInformationPromptType"] = 6] = "OfferContactInformationPromptType";
    SiteSettingType[SiteSettingType["CheckCprBeforeCalculation"] = 7] = "CheckCprBeforeCalculation";
    SiteSettingType[SiteSettingType["ShowCallMeModalOnTerminatePolicy"] = 8] = "ShowCallMeModalOnTerminatePolicy";
})(SiteSettingType || (exports.SiteSettingType = SiteSettingType = {}));
